import { Badge } from '@shared-ui/components';
import { stateOf, type BackupRow } from './driveBackupFormat';

export function BackupStateBadge({ row }: { row: BackupRow }) {
  const s = stateOf(row);
  if (s === 'disconnected') return <Badge variant="error" size="md">Access revoked</Badge>;
  if (s === 'paused') return <Badge variant="warning" size="md">Drive full</Badge>;
  if (s === 'stalled') return <Badge variant="warning" size="md">Not sweeping</Badge>;
  return <Badge variant="success" size="md">Active</Badge>;
}
